<template>
    <div>
        <div v-if="automationActions.length > 0" class="flex ml-2 align-items-center">
            <div class="ml-1">
                <button class="btn btn-yellow text-capitalize">{{ automationActions[0].type ? automationActions[0].type.replace('action_', '') : '' }}</button>
            </div>
            <div class="ml-1">
                <button class="btn btn-primary text-capitalize">{{ automationActions[0].object ? automationActions[0].object.replace('action_', '') : ''}}</button>
            </div>
            <div class="ml-1">
                <div v-if="automationActions[0].type === 'action_update'" class="flex align-items-center">
                    <div v-if="automationActions[0].object === 'action_sequence'" class="flex align-items-center">
                        <span class="mr-1">Sequence</span>
                        <button type="button" class="btn btn-primary text-capitalize">{{ automationActions[0].sequence_name }}</button>
                    </div>
                    <div v-else>{{ automation.update_action_labels['actionId-' + automationActions[0].id] }}</div>
                </div>
                <div v-if="automationActions[0].type === 'action_email'" class="flex align-items-center">
                    <button v-if="automationActions[0].object !== 'action_contact'" type="button" class="btn btn-light-red mr-1">{{ automation.email_action_labels['actionId-' + automationActions[0].id] }}</button>
                    <div class="flex align-items-center">
                        <span class="mr-1">Template</span>
                        <button type="button" class="btn btn-primary text-capitalize">{{ automationActions[0].template_name }}</button>
                    </div>
                </div>
            </div>
            <div class="ml-1" v-if="automationActions.length > 1">
                <button type="button" class="btn btn-secondary">+{{ automationActions.length - 1 }} additional action{{ automationActions.length > 1 ? 's' : '' }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment/moment";

export default {
    name: 'AutomationActionList',
    props: ['automation', 'masks'],
    data() {
        return {
            automationActions: []
        }
    },
    created() {
        this.mapAutomationActionsData();
    },
    methods: {
        mapAutomationActionsData() {
            let self = this;
            this.automationActions = _.map(self.automation.actions, (action) => {
                if(action.sales_behavior_id && action.sales_behavior_time) {
                    if(action.is_fixed_date) {
                        const formattedDateTime = moment.utc(moment(action.value).format("YYYY-MM-DD") + ' ' + action.sales_behavior_time).local().format("YYYY-MM-DD HH:mm:ss");
                        self.automation.update_action_labels['actionId-' + action.id] = 'Set ' + _.startCase(action.field) + ' to ' + moment(formattedDateTime).format(this.masks.full_date_time_mask);
                    }
                    else if(!action.not_fixed_date_action) {
                        const formattedTime = moment.utc(action.sales_behavior_time, "HH:mm:ss").local().format("hh:mm A");
                        self.automation.update_action_labels['actionId-' + action.id] = 'Set ' + _.startCase(action.field) + ' to ' + action.value + ' days ' + '(Time: ' + formattedTime + ') after automation triggered';
                    }
                }
                return action;
            });
        }
    }
}
</script>

<style scoped>
.btn-light-red {
    background: #f87676;
}
.btn-purple {
    background: #6e7ff2;
}
.btn-yellow {
    background: #f8f582;
}
</style>
